// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// ASP #27/#28 — the therapy's pharmacist, shown and changeable from the care plan. The same ReviewAssignee
// control as the Clinical Review queue; it names the pharmacist without changing the review status, and the
// new pharmacist's notification says "care plan". Completing the plan names the completing pharmacist on the
// server when nobody is assigned, so the panels refresh this after a sign / attested save.

import { useState } from 'react'
import { useAuth } from '../../auth/AuthContext'
import { friendlyError } from '../../api/errors'
import { useAssignReview, useReviewAssignment } from '../../hooks/queries/carerxClinical'
import ReviewAssignee from './ReviewAssignee'

export default function CarePlanAssignee({ therapyId }: { therapyId: string }) {
  const { me } = useAuth()
  const a = useReviewAssignment(therapyId)
  const assign = useAssignReview()
  const [note, setNote] = useState<string | null>(null)
  if (a.isPending || a.isError) return null   // advisory: the plan works without it
  const selfAssign = () => {
    if (!me?.account_id) return
    assign.mutate({ therapyId, rphId: me.account_id, keepStatus: true, context: 'care_plan' },
      { onSuccess: () => setNote(null), onError: e => setNote(friendlyError(e)) })
  }
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12 }}>
      <span style={{ color: 'var(--color-text-mute)', paddingTop: 1 }}>Pharmacist:</span>
      <ReviewAssignee therapyId={therapyId} rphId={a.data.assigned_rph_id} rphName={a.data.rph_name}
        assignedAt={a.data.assigned_at} keepStatus context="care_plan" onSelf={selfAssign} onChanged={setNote} />
      {note && <span style={{ fontSize: 11, color: 'var(--color-text-mute)' }}>{note}</span>}
    </div>
  )
}
